import { render, staticRenderFns } from "./ProductIsland.vue?vue&type=template&id=a73ab7c6&"
import script from "./ProductIsland.vue?vue&type=script&lang=js&"
export * from "./ProductIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports